"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setProductRelationshipOfferingSelectedPrice = exports.setProductRelationshipOffering = exports.setHandsets = exports.fetchProductRelationshipOffering = exports.fetchLowestPlanPrice = exports.fetchHandsets = exports.fetchAddressSuggestions = exports.SET_PRODUCT_RELATIONSHIP_OFFERING_SELECTED_PRICE = exports.SET_PRODUCT_RELATIONSHIP_OFFERING = exports.SET_PLAN_LOWEST_PRICE = exports.SET_HANDSETS = exports.FETCH_PRODUCT_RELATIONSHIP_OFFERING = exports.FETCH_LOWEST_PLAN_PRICE = exports.FETCH_HANDSETS = exports.FETCH_BROADBAND_ADDRESSES_SUCCESS = exports.FETCH_BROADBAND_ADDRESSES_ERROR = exports.FETCH_BROADBAND_ADDRESSES = void 0;
const FETCH_HANDSETS = 'FETCH_HANDSETS';
exports.FETCH_HANDSETS = FETCH_HANDSETS;
const SET_HANDSETS = 'SET_HANDSETS';
exports.SET_HANDSETS = SET_HANDSETS;
const FETCH_PRODUCT_RELATIONSHIP_OFFERING = 'FETCH_PRODUCT_RELATIONSHIP_OFFERING';
exports.FETCH_PRODUCT_RELATIONSHIP_OFFERING = FETCH_PRODUCT_RELATIONSHIP_OFFERING;
const SET_PRODUCT_RELATIONSHIP_OFFERING = 'SET_PRODUCT_RELATIONSHIP_OFFERING';
exports.SET_PRODUCT_RELATIONSHIP_OFFERING = SET_PRODUCT_RELATIONSHIP_OFFERING;
const SET_PRODUCT_RELATIONSHIP_OFFERING_SELECTED_PRICE = 'SET_PRODUCT_RELATIONSHIP_OFFERING_SELECTED_PRICE';
exports.SET_PRODUCT_RELATIONSHIP_OFFERING_SELECTED_PRICE = SET_PRODUCT_RELATIONSHIP_OFFERING_SELECTED_PRICE;
const FETCH_BROADBAND_ADDRESSES = 'FETCH_BROADBAND_ADDRESSES';
exports.FETCH_BROADBAND_ADDRESSES = FETCH_BROADBAND_ADDRESSES;
const FETCH_BROADBAND_ADDRESSES_SUCCESS = 'FETCH_BROADBAND_ADDRESSES_SUCCESS';
exports.FETCH_BROADBAND_ADDRESSES_SUCCESS = FETCH_BROADBAND_ADDRESSES_SUCCESS;
const FETCH_BROADBAND_ADDRESSES_ERROR = 'FETCH_BROADBAND_ADDRESSES_ERROR';
exports.FETCH_BROADBAND_ADDRESSES_ERROR = FETCH_BROADBAND_ADDRESSES_ERROR;
const FETCH_LOWEST_PLAN_PRICE = 'FETCH_LOWEST_PLAN_PRICE';
exports.FETCH_LOWEST_PLAN_PRICE = FETCH_LOWEST_PLAN_PRICE;
const SET_PLAN_LOWEST_PRICE = 'SET_PLAN_LOWEST_PRICE';
exports.SET_PLAN_LOWEST_PRICE = SET_PLAN_LOWEST_PRICE;
const fetchHandsets = () => ({
  type: FETCH_HANDSETS
});
exports.fetchHandsets = fetchHandsets;
const fetchLowestPlanPrice = () => ({
  type: FETCH_LOWEST_PLAN_PRICE
});
exports.fetchLowestPlanPrice = fetchLowestPlanPrice;
const setHandsets = handsets => ({
  type: SET_HANDSETS,
  payload: {
    handsets
  }
});
exports.setHandsets = setHandsets;
const fetchProductRelationshipOffering = relationshipIds => ({
  type: FETCH_PRODUCT_RELATIONSHIP_OFFERING,
  payload: {
    relationshipIds
  }
});
exports.fetchProductRelationshipOffering = fetchProductRelationshipOffering;
const setProductRelationshipOffering = productOffering => ({
  type: SET_PRODUCT_RELATIONSHIP_OFFERING,
  payload: {
    productOffering
  }
});
exports.setProductRelationshipOffering = setProductRelationshipOffering;
const setProductRelationshipOfferingSelectedPrice = (id, price) => ({
  type: SET_PRODUCT_RELATIONSHIP_OFFERING_SELECTED_PRICE,
  payload: {
    id,
    price
  }
});
exports.setProductRelationshipOfferingSelectedPrice = setProductRelationshipOfferingSelectedPrice;
const fetchAddressSuggestions = address => ({
  type: FETCH_BROADBAND_ADDRESSES,
  payload: {
    address
  }
});
exports.fetchAddressSuggestions = fetchAddressSuggestions;